import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Interceptor } from "../app/shared/interceptor";
import { AppComponent } from "./app.component";
import { AuthServiceService } from "./shared/auth/auth-service.service";
import { ToastrModule } from "ngx-toastr";
import { LoaderComponent } from "./loader/loader.component";
import { MatButtonModule, MatDialogModule } from "@angular/material";
import { MatProgressSpinnerModule } from "@angular/material";
import { LoadingInterceptor } from "./loadingService/loading.interceptor";
import { LoadingService } from "./loadingService/loading.service";

@NgModule({
  declarations: [AppComponent, LoaderComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: "toast-bottom-right",
      preventDuplicates: true
    }),
    BrowserAnimationsModule
  ],
  providers: [
    LoadingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    AuthServiceService,
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true }
  ],
  bootstrap: [AppComponent],
  exports: [LoaderComponent]
})
export class AppModule {}
